

































































import {Component} from '@/shared/component';
import {AbstractEditVue} from '@/components/Abstract/AbstractEditVue';
import {Fournisseur} from '@/models';

import storeFournisseur from '@/stores/modules/fournisseur';

import CrudAddressEdit from '@/components/Crud/Address/Edit.vue';
import InputCountry from "@/components/Input/Country.vue";
import InputZipCode from "@/components/Input/ZipCode.vue";

@Component({
	components: {
		CrudAddressEdit,
		InputCountry,
		InputZipCode,
	}
})
export default class CrudFournisseurAdressesEdit extends AbstractEditVue<Fournisseur> {

	public constructor() {
		super(
			storeFournisseur,
			'Fournisseur modifié',
			'Fournisseur créé',
		);
	}

	public async mounted(): Promise<void> {
		await super.mounted();
	}

	public async refresh(): Promise<void> {
		await super.refresh();
	}

}
